import { createApp } from 'vue'
import { createPinia } from 'pinia'

import { Loading, Meta, Notify, Quasar } from 'quasar'
import quasarIconSet from 'quasar/icon-set/svg-mdi-v6'
import '@quasar/extras/mdi-v6/mdi-v6.css'
import 'quasar/src/css/index.sass'

import App from '@/App.vue'
import router from '@/router'

import * as Sentry from '@sentry/vue'

import VueMatomo from 'vue-matomo'

import { lightBrandColors as brand } from '@/assets/style/brandColors'

import '@vue-unistra/timelinejs/timeline.css'

import i18n from '@/plugins/i18n'
import authService from '@/services/AuthService.ts'

const app = createApp(App)

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

if (import.meta.env.VITE_APP_MATOMO_SERVER && import.meta.env.VITE_APP_MATOMO_SITE_ID) {
  app.use(VueMatomo, {
    router,
    host: import.meta.env.VITE_APP_MATOMO_SERVER,
    siteId: import.meta.env.VITE_APP_MATOMO_SITE_ID,
    debug: import.meta.env.VITE_APP_MATOMO_DEBUG || false,
  })
}

app.use(i18n)
app.use(createPinia())
app.use(router)
app.use(Quasar, {
  plugins: {
    Loading,
    Meta,
    Notify,
  },
  iconSet: quasarIconSet,
  config: {
    loading: {},
    brand,
    notify: {},
  },
})

app.mount('#app')

authService.setLanguage(localStorage.getItem('octantLocale') ?? import.meta.env.VITE_APP_I18N_LOCALE)
